<script>
	import { user, page, params } from './stores.js';
	import MyRouter from './components/Router.svelte';
	import Login from './components/Auth/Login.svelte';

	user.useLocalStorage();

	// The active route component, set by Router.svelte via the `page` store.
	// This must be a reactive `$derived` rather than a block-scoped `{@const}`:
	// `{@const}` is fixed for the lifetime of its enclosing block, so a const
	// inside `{#if $page}` only re-instantiates when the `{#if}` toggles — it
	// never swaps the mounted component while navigating between two routes
	// (both truthy). `$derived` reassigns reactively, so the component swaps.
	const RouteComponent = $derived($page);
</script>

<div class="container-fluid">
    <header>
        <div class="logo-container">
            <a href="/"><img src="/ce_logo.svg" aria-label="CareEvolution" alt="CareEvolution Logo"></a>
            <h1><a href="/">SecureShare</a></h1>
        </div>
        <div class="utility"><Login></Login></div>
    </header>
    
	<MyRouter></MyRouter>

	{#if RouteComponent}
		<RouteComponent params={$params} />
	{/if}

    <footer class="small" style="text-align: center">&copy; 2026 CareEvolution, LLC

        <div class="background-lock">
            <img src="/lock-solid.svg" aria-label="SecureShare" alt="CareEvolution SecureShare">
        </div>
        

    </footer>
    
</div>       

<style>
    :global(div.spinner > div) {
        margin: 0 0;
    }
</style>
